import { useCallback, useMemo } from 'react';
import useObjectTypeId from 'framework-listing-lib/internal/hooks/useObjectTypeId';
import { safeParseJSON } from 'framework-listing-lib/utils/json';
import { useReadLocalStore, useWriteLocalStore } from '../../hooks/useLocalStore';
function getColumnConfigurationKey(objectType) {
  return `CustomColumnsConfig-${objectType}`;
}
function useFetchColumnConfiguration(objectType) {
  const key = getColumnConfigurationKey(objectType);
  return useReadLocalStore(key);
}
export default function useTableColumnConfiguration() {
  const objectType = useObjectTypeId();
  const [writeLocalStore] = useWriteLocalStore();
  const {
    data,
    loading
  } = useFetchColumnConfiguration(objectType);
  const columnConfiguration = useMemo(() => data ? safeParseJSON(data.value, {}) : undefined, [data]);
  const saveColumnConfiguration = useCallback(newConfig => {
    return writeLocalStore({
      key: getColumnConfigurationKey(objectType),
      value: JSON.stringify(newConfig)
    }).catch(error => {
      throw error;
    });
  }, [objectType, writeLocalStore]);
  return useMemo(() => ({
    saveColumnConfiguration,
    columnConfiguration,
    loading
  }), [columnConfiguration, saveColumnConfiguration, loading]);
}